var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-inner" }, [
    _c("div", { staticClass: "app-main-inner-row" }, [
      _c(
        "div",
        { staticClass: "filters" },
        [
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                "label-width": _vm.isZh ? "80px" : "125px",
                "label-position": "left"
              }
            },
            [
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.labelName } },
                    [
                      _vm.criteriaType === 1
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              no: "Customer",
                              disabled: _vm.locked,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": { customer: true, active: true },
                              "callback-method-type": "value",
                              "default-value": _vm.criteriaValue,
                              "callback-params": { key: "customerId" }
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 2
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              no: "BusinessType",
                              disabled: _vm.locked,
                              filterable: "",
                              "tag-name": _vm.isZh
                                ? "chineseName"
                                : "englishName",
                              "tag-value": "code",
                              "static-options": [].concat(
                                _vm.SystemConstants.SE
                              ),
                              "default-value": _vm.criteriaValue
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 3
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              no: "CargoType",
                              disabled: _vm.locked,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CargoType,
                              "callback-params": { key: "cargoType" },
                              "callback-method-type": "value",
                              "default-value": _vm.criteriaValue
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 4
                        ? _c(
                            "el-select",
                            {
                              staticStyle: { width: "205px" },
                              attrs: {
                                no: "ContainerType",
                                disabled: _vm.locked,
                                filterable: "",
                                placeholder: ""
                              },
                              on: { parentCallBack: _vm.getValue },
                              model: {
                                value: _vm.criteriaValue,
                                callback: function($$v) {
                                  _vm.criteriaValue = $$v
                                },
                                expression: "criteriaValue"
                              }
                            },
                            _vm._l(_vm.containerTypeArrays, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  value: item.code,
                                  label: _vm.isZh
                                    ? item.chineseName
                                    : item.englishName
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                      _vm.criteriaType === 5
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "SeaPol",
                              disabled: _vm.locked,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              "callback-params": { key: "criteriaValue" },
                              "callback-method-type": "value",
                              "clear-not-match": true,
                              "default-value": _vm.criteriaValue
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 6
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "SeaPod",
                              disabled: _vm.locked,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              "callback-params": { key: "criteriaValue" },
                              "callback-method-type": "value",
                              "clear-not-match": true,
                              "default-value": _vm.criteriaValue
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 7
                        ? _c("el-input", {
                            directives: [
                              { name: "uppercase", rawName: "v-uppercase" }
                            ],
                            staticStyle: { width: "286px" },
                            attrs: { no: "Shipper", disabled: _vm.locked },
                            model: {
                              value: _vm.criteriaValue,
                              callback: function($$v) {
                                _vm.criteriaValue = $$v
                              },
                              expression: "criteriaValue"
                            }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 8
                        ? _c("el-input", {
                            directives: [
                              { name: "uppercase", rawName: "v-uppercase" }
                            ],
                            staticStyle: { width: "286px" },
                            attrs: { no: "Consignee", disabled: _vm.locked },
                            model: {
                              value: _vm.criteriaValue,
                              callback: function($$v) {
                                _vm.criteriaValue = $$v
                              },
                              expression: "criteriaValue"
                            }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 9
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              no: "Carrier",
                              disabled: _vm.locked,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": { seaCmp: true, active: true },
                              "custom-label": function(item) {
                                return "" + item.chineseName
                              },
                              "show-custom-label-in-option": true,
                              "default-value": _vm.criteriaValue
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 10
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              no: "BookingAgent",
                              disabled: _vm.locked,
                              filterable: "",
                              "options-width": "250px",
                              "method-params": {
                                bookingAgent: true,
                                active: true
                              },
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "default-value": _vm.criteriaValue
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 11
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              no: "RouteArea",
                              disabled: _vm.locked,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Region,
                              "callback-params": { key: "region" },
                              "callback-method-type": "value",
                              "default-value": _vm.criteriaValue
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 12
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              no: "DesignationAgent",
                              disabled: _vm.locked,
                              filterable: "",
                              "tag-name": "englishName",
                              "options-width": "250px",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": {
                                overseaAgent: true,
                                active: true
                              },
                              "default-value": _vm.criteriaValue
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 13
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              no: "NominatedAgent",
                              disabled: _vm.locked,
                              filterable: "",
                              "options-width": "250px",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": {
                                designationAgent: true,
                                active: true
                              },
                              "default-value": _vm.criteriaValue
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 14
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              no: "AvailableBranch",
                              disabled: _vm.locked,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Office,
                              "callback-params": { key: "criteriaValue" },
                              "default-value": _vm.criteriaValue,
                              "method-params": {},
                              "custom-label": function(item) {
                                return (
                                  "[" +
                                  item.code +
                                  "]" +
                                  (_vm.isZh
                                    ? item.chineseName
                                    : item.englishName)
                                )
                              },
                              "filter-tag-names": [
                                "code",
                                _vm.isZh ? "chineseName" : "englishName"
                              ],
                              "show-custom-label-in-option": true
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "Add",
                            disabled: _vm.locked,
                            type: "primary"
                          },
                          on: { click: _vm.add }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_add")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "Delete",
                            disabled: _vm.locked,
                            type: "danger"
                          },
                          on: { click: _vm.remove }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ]),
    _c(
      "div",
      {
        staticClass: "app-main-inner-row row-grid",
        staticStyle: { "min-height": "400px" }
      },
      [
        _c("cargo-ag-grid", {
          staticStyle: { width: "100%" },
          attrs: {
            "config-module": "200201",
            "show-side-bar": false,
            "grid-params": _vm.gridParams,
            "grid-options": _vm.gridOptions,
            "column-defs": _vm.columnDefs,
            "row-data": _vm.rowData
          },
          on: {
            "update:gridParams": function($event) {
              _vm.gridParams = $event
            },
            "update:grid-params": function($event) {
              _vm.gridParams = $event
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }